<template>
    <div
        role="button"
        tabindex="0"
        class="group rounded-muval-1 hover:bg-muval-gray-6 flex cursor-pointer items-start gap-3 px-2 py-2 text-left transition-colors"
        @click="$emit('click')"
        @keydown.enter.prevent="$emit('click')"
        @keydown.space.prevent="$emit('click')"
    >
        <div class="flex grow flex-col gap-0.5">
            <div class="text-sm">{{ truncatedMessage }}</div>
            <div class="text-muval-gray-3 flex items-center gap-1 text-xs">
                <span>{{ timeAgo }}</span>
                <span aria-hidden="true">·</span>
                <button
                    type="button"
                    class="hover:text-muval-gray-1 hover:underline"
                    @click.stop="$emit('dismiss')"
                >
                    Dismiss
                </button>
            </div>
        </div>
        <div
            v-if="actionLink"
            class="shrink-0"
            @click.stop
        >
            <a :href="actionLink.url">
                <div class="grid size-10 shrink-0 place-items-center rounded-full border bg-white">
                    <SvgIcon
                        name="system-phone"
                        class="text-success size-5"
                    />
                </div>
            </a>
            <!-- <MuvalButton
                small
                tertiary
                icon="system-phone"
                circle
                :href="actionLink.url"
            /> -->
        </div>
    </div>
</template>

<script setup lang="ts">
import { useTimeAgo } from '@vueuse/core';

const props = defineProps<{
    notification: {
        id: string;
        created_at?: string | null;
        data: {
            message?: string;
            url?: string;
            action?: { type: string; url: string; label: string };
        };
    };
}>();

defineEmits<{
    (e: 'click'): void;
    (e: 'dismiss'): void;
}>();

const timestamp = computed(() =>
    props.notification.created_at ? new Date(props.notification.created_at) : new Date(),
);
const timeAgo = useTimeAgo(timestamp);

const truncatedMessage = computed(() => {
    const message = props.notification.data?.message ?? '';
    if (message.length <= 140) {
        return message;
    }
    const truncated = message.slice(0, 140);
    const lastSpace = truncated.lastIndexOf(' ');
    return (lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated) + '…';
});

const actionLink = computed(() => {
    const action = props.notification.data?.action;
    if (!action || action.type !== 'link' || !action.url) {
        return null;
    }
    return action;
});
</script>
